export const background =
  "I'm a musician, and also have worked as a school teacher.";

export const motivation =
  "I'm motivated by the vision of becoming better each day.";

export const experience =
  'Teaching has expanded my view on teamwork and collaboration';

export const interests = 'Exploring new tech or building my own computers.';

export const aspirations =
  'To be a strong contributor to the developer community.';

export const mindset =
  'Maintaining a positive mindset is crucial for growth.';
